import { Button, H3, Modal, P, PropsModal } from '@vgrubs/components';

export const WhatIsThisModal = ({
  modalIsOpen,
  closeModal,
}: PropsModal & {
  modalIsOpen: boolean;
}) => {
  return (
    <Modal isOpen={modalIsOpen} closeModal={closeModal} vDriveLogo>
      <H3>What is this?</H3>

      <P>
        Introducing vDrive - designed to simplify the way you assign drivers to
        your delivery orders, and all on demand! Just flip the switch and cut
        your delivery platform's percentage fees in nearly half with our pay-
        per-delivery solution, perfectly integrated and automated.
      </P>

      <Button $w="100%" $selected onClick={() => closeModal?.()}>
        Okay
      </Button>
    </Modal>
  );
};
